import React from 'react';

const CCCertificate = ({ studentName, courseTitle, startDate, completionDate, issueDate, instructorName, directorName, institutionName }) => {
    const styles = {
        certificateContainer: {
            width: '80%',
            margin: '0 auto',
            padding: '2rem',
            border: '1px solid #ddd',
            boxShadow: '0 0 10px rgba(0,0,0,0.1)',
            fontFamily: 'Arial, sans-serif',
            textAlign: 'center',
            color: '#333',
        },
        institutionName: {
            fontSize: '2rem',
            fontWeight: 'bold',
            marginBottom: '0.5rem',
        },
        subtitle: {
            fontSize: '1.2rem',
            color: '#555',
            marginBottom: '2rem',
        },
        headerText: {
            fontSize: '1.8rem',
            fontWeight: 'bold',
            margin: '1rem 0',
            color: '#4b4b4b',
        },
        studentName: {
            fontSize: '1.6rem',
            fontWeight: 'bold',
            color: '#222',
            margin: '1rem 0',
        },
        courseTitle: {
            fontSize: '1.4rem',
            fontWeight: 'bold',
            color: '#222',
            marginBottom: '2rem',
        },
        infoText: {
            fontSize: '1rem',
            color: '#333',
            marginBottom: '0.5rem',
        },
        signatureContainer: {
            display: 'flex',
            justifyContent: 'space-around',
            marginTop: '3rem',
        },
        signatureBlock: {
            textAlign: 'center',
            fontSize: '1rem',
            color: '#333',
        },
        signatureLine: {
            display: 'block',
            margin: '1rem 0 0.5rem',
            borderTop: '1px solid #333',
            width: '200px',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    };

    return (
        <div style={styles.certificateContainer}>
            <div style={styles.institutionName}>{institutionName}</div>
            <div style={styles.subtitle}>Address, City, State, ZIP Code | Phone Number</div>
            <div style={styles.headerText}>Certificate of Completion</div>
            <div style={styles.infoText}>This certifies that</div>
            <div style={styles.studentName}>{studentName}</div>
            <div style={styles.infoText}>has successfully completed the course</div>
            <div style={styles.courseTitle}>{courseTitle}</div>
            <div style={styles.infoText}>
                <strong>Course Duration:</strong> {startDate} - {completionDate}
            </div>
            <div style={styles.infoText}>
                <strong>Issued on:</strong> {issueDate}
            </div>
            <div style={styles.signatureContainer}>
                <div style={styles.signatureBlock}>
                    <span style={styles.signatureLine}></span>
                    <div>{instructorName}</div>
                    <small>Instructor/Faculty</small>
                </div>
                <div style={styles.signatureBlock}>
                    <span style={styles.signatureLine}></span>
                    <div>{directorName}</div>
                    <small>Director/Principal</small>
                </div>
            </div>
            <div style={{ ...styles.infoText, marginTop: '3rem', color: '#777' }}>
                Congratulations on your achievement!
            </div>
        </div>
    );
};

export default CCCertificate
